module.exports = __webpack_public_path__ + "static/media/copy_all_white_24dp.a068b33a.svg";